// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, WORKER_URL } from '../configs/constants';

const EMPREENDIMENTO_DETAIL_TIMEOUT_MS = 10000;

// requests
export async function cities_types(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            cidades {
                id
                nome
                id_estado
                url_foto
            }
            tipos {
                id
                nome
            }
        }
    `;
    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function categorias(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            categorias {
                id
                nome
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function get_estados(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            estados {
                id
                nome
                pais
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function allCaracteristicas(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            caracteristicas {
                id
                nome
                imovel
                condominio
            }
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function allDatasEntrega(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            datas_entrega
        }
    `;
     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getCompany(nameCompany?: string, origin?: string, codsite?: number, mostrar_site?: boolean,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const expandedQuery = gql`
        {
            empreendimentos(nome: ${JSON.stringify(nameCompany || '')} ${mostrar_site ? `,mostrar_site: ${mostrar_site}` : ''}) {
                id
                nome
                Estado
                Pais
                referencia
                endereco
                construtora
                cep
                id_estado
                id_cidade
                id_bairro
                cidade
                bairro
                latitude_longitude
                unidades
                unidades_andar
                torres
                andares
                tipos_emp_detalhes {
                    id
                    nome
                }
                categoria_empreendimento {
                    id_categoria
                    nome
                }
                caracteristicas_detalhes {
                    id
                    nome
                }
                mostrar_site
                destaque
                foto_360
                meta_description
                meta_keywords
                meta_title
                descricao
                situacao
                porcentagem_vendido
                porcetagem_praca_alimentacao
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                preco_min
                preco_max
                area_privativa_min
                area_privativa_max
                fotos {
                  id
                  descricao
                  posicao
                  categoria
                  destaque
                  id_empreendimento
                  tipo
                  banner
                  url_foto
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimentos(nome: ${JSON.stringify(nameCompany || '')} ${mostrar_site ? `,mostrar_site: ${mostrar_site}` : ''}) {
                id
                nome
                Estado
                Pais
                referencia
                endereco
                construtora
                cep
                id_estado
                id_cidade
                id_bairro
                latitude_longitude
                unidades
                unidades_andar
                torres
                andares
                mostrar_site
                destaque
                foto_360
                meta_description
                meta_keywords
                meta_title
                descricao
                situacao
                porcentagem_vendido
                porcetagem_praca_alimentacao
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                preco_min
                preco_max
                area_privativa_min
                area_privativa_max
                fotos {
                  id
                  descricao
                  posicao
                  categoria
                  destaque
                  id_empreendimento
                  tipo
                  banner
                  url_foto
                }
            }
        }
    `;

     try {
const data = await graphQLClient.request(expandedQuery);
        return data;
    } catch (error) {
        try {
            const data = await graphQLClient.request(legacyQuery);
            return data;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getCompanySearch(
    pagina: number,
    qtd_pag?: number,
    nome?: string,
    cidade?: string,
    bairro?: string,
    preco_min?: number,
    preco_max?: number,
    tipo?: number,
    origin?: string,
    codsite?: number,
    prodOrigin?: any
): Promise<any> {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if (prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient =
        prodOrigin ?
            new GraphQLClient(endpoint, {
                headers: {
                    ...headers2,
                    dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                    'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                    codsite: codsite ? codsite : 0
                },
            }) : new GraphQLClient(endpoint, {
                headers: {
                    ...headers,
                    dominion: typeof window !== 'undefined' ? window.location.origin : origin,
                    'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
                    codsite: codsite ? codsite : 0
                },
            });

    const page = Number(pagina) > 0 ? Number(pagina) : 1;
    const perPage = Number(qtd_pag) > 0 ? Number(qtd_pag) : 12;

    const queryArgs = `
                pagina: ${page},
                qtd_pag: ${perPage}
                ${nome ? `, nome: ${JSON.stringify(nome)}` : ''}
                ${cidade ? `, cidade: ${JSON.stringify(cidade)}` : ''}
                ${bairro ? `, bairro: ${JSON.stringify(bairro)}` : ''}
                ${typeof preco_min === 'number' ? `, preco_min: ${preco_min}` : ''}
                ${typeof preco_max === 'number' ? `, preco_max: ${preco_max}` : ''}
                ${typeof tipo === 'number' ? `, tipo: ${tipo}` : ''}
    `;

    const expandedQuery = gql`
        {
            empreendimentos_busca(
${queryArgs}
            ) {
                count
                empreendimentos {
                    id
                    nome
                    id_cidade
                    cidade
                    bairro
                    descricao
                    endereco
                    dormitorios
                    suites
                    vagas
                    id_tipos
                    tipos_emp
                    tipos_emp_detalhes {
                        id
                        nome
                        codsite
                    }
                    id_categoria
                    categoria_empreendimento {
                        id_categoria
                        nome
                        codsite
                    }
                    preco_min
                    preco_max
                    are_privativa_min
                    area_privativa_min
                    area_privativa_max
                    situacao
                    logo
                    urlAmigavel
                    mostrar_site
                    fotos {
                        id
                        url_foto
                        categoria
                        descricao
                        destaque
                    }
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimentos_busca(
${queryArgs}
            ) {
                count
                empreendimentos {
                    id
                    nome
                    id_cidade
                    cidade
                    bairro
                    id_tipos
                    tipos_emp
                    tipos_emp_detalhes {
                        id
                        nome
                        codsite
                    }
                    id_categoria
                    categoria_empreendimento {
                        id_categoria
                        nome
                        codsite
                    }
                    preco_min
                    preco_max
                    are_privativa_min
                    area_privativa_min
                    area_privativa_max
                    situacao
                    logo
                    urlAmigavel
                    mostrar_site
                    fotos {
                        id
                        url_foto
                        categoria
                    }
                }
            }
        }
    `;

    try {
        const expandedData = await graphQLClient.request(expandedQuery);
        return expandedData;
    } catch (error) {
        try {
            const legacyData = await graphQLClient.request(legacyQuery);
            return legacyData;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getEmpreendimentoById(
    id: number,
    origin?: string,
    codsite?: number,
    prodOrigin?: any
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const empreendimentoId = Number(id);
    if (!Number.isFinite(empreendimentoId) || empreendimentoId <= 0) {
        return null;
    }

    const isServerRequest = typeof window === 'undefined';
    const endpoint = isServerRequest && prodOrigin
        ? (WORKER_URL || 'https://novaapi.sobressai.com.br/')
        : '/api/gql';

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...(isServerRequest && prodOrigin ? headers2 : headers),
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `empreendimento_specific_${empreendimentoId}`
        },
    });

    const expandedQuery = gql`
        {
            empreendimento(id: ${empreendimentoId}) {
                id
                nome
                id_tipos
                endereco
                cep
                Estado
                id_estado
                bairro
                cidade
                uf
                caracteristicas_detalhes {
                    id
                    nome
                }
                tipos_emp_detalhes {
                    id
                    nome
                }
                categoria_empreendimento {
                    id_categoria
                    nome
                }
                construtora
                descricao
                Descricao_interna
                situacao
                preco_min
                preco_max
                are_privativa_min
                area_privativa_min
                area_privativa_max
                dormitorios
                suites
                banheiros
                vagas
                unidades
                torres
                andares
                mostrar_site
                meta_description
                meta_keywords
                meta_title
                urlAmigavel
                siteEmpreendimento
                VideosEmpre
                latitude_longitude
                porcentagem_vendido
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                fotos {
                    id
                    descricao
                    posicao
                    categoria
                    destaque
                    id_empreendimento
                    tipo
                    banner
                    url_foto
                }
            }
        }
    `;

    const legacyQuery = gql`
        {
            empreendimento(id: ${empreendimentoId}) {
                id
                nome
                id_tipos
                endereco
                cep
                bairro
                cidade
                uf
                construtora
                descricao
                Descricao_interna
                situacao
                preco_min
                preco_max
                are_privativa_min
                area_privativa_min
                area_privativa_max
                dormitorios
                suites
                banheiros
                vagas
                unidades
                torres
                andares
                mostrar_site
                meta_description
                meta_keywords
                meta_title
                urlAmigavel
                siteEmpreendimento
                VideosEmpre
                latitude_longitude
                porcentagem_vendido
                porcetagem_estrutura
                porcetagem_telhado
                porcetagem_areade_entrada
                fotos {
                    id
                    descricao
                    posicao
                    categoria
                    destaque
                    id_empreendimento
                    tipo
                    banner
                    url_foto
                }
            }
        }
    `;

    const requestWithTimeout = async (document: string) => {
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const timeoutId = controller
            ? setTimeout(() => controller.abort(), EMPREENDIMENTO_DETAIL_TIMEOUT_MS)
            : null;

        try {
            if (!controller) {
                return await graphQLClient.request(document);
            }

            return await graphQLClient.request({
                document,
                signal: controller.signal
            } as any);
        } finally {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        }
    };

    try {
        const data = await requestWithTimeout(expandedQuery);
        return data;
    } catch (error) {
        try {
            const data = await requestWithTimeout(legacyQuery);
            return data;
        } catch (legacyError) {
            return null;
        }
    }
}

export async function getCompany_rodape(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function district(idCity: number, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });
    const query = gql`
        {
            bairros(id_cidade: ${idCity}) {
                id
                nome
                id_cidade
            }
        }
    `;

     try {
        
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function getFilterPrices(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            precos_locacao {
                min
                max
            }
            precos_venda {
                min
                max
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
